import { MarkdownViewer } from '@/business-components/markdown-viewer/MarkdownViewer';
import { AppTheme } from '@/shared/constant/AppTheme';
import clsx from 'clsx';
import styles from './RequestSampleCodePrompt.module.css';

export type RequestSampleCodePromptProps = {
  className?: string;
  value: string | undefined;
};

export function RequestSampleCodePrompt(props: RequestSampleCodePromptProps) {
  const { className, value } = props;

  if (!value) {
    return null;
  }
  return (
    <div className={clsx('px-4', className)}>
      <div className="border-b border-b-[#222A39] pb-2" data-theme={AppTheme.Dark}>
        <MarkdownViewer
          className={clsx('max-h-[50px] overflow-y-auto', styles.prompt)}
          value={value}
          enableHeaderPlugin={false}
          inDocView={false}
          theme={AppTheme.Dark}
        />
      </div>
    </div>
  );
}
